import { setMinHeight } from "./utils/_utils";
jQuery(function ($) {
  $(document).on('click', '#customer_login .close', function () {
    jQuery.magnificPopup.close();
  });
  $(document).on('click', '.woocommerce-error .close', function () {
    $(this).closest('.woocommerce-error.message-wrapper').remove();
  });
  var delay = 100;
  setTimeout(function () {
    $('.e-n-accordion-item').removeAttr('open'); // Remove the 'open' attribute
  }, delay);
});